import React from 'react';
import { Redirect, Route } from 'react-router';
import { useSubscription } from '@meraki-internal/state';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CarePage } from '../care/CarePage';
import { CareMapState } from '../caremap/CareMapState';
import { HeaderTabsState } from '../HeaderTabs';

export const CareRouter: React.FC = () => {

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const tabsState = useInstance(HeaderTabsState);
    useSubscription(() => tabsState);

    return (
        <>
            <Route path="/care-redirect" exact render={() => {
                const lastTab = tabsState.getLastActiveTab('care-tabs');
                const careMap = careMapState.getMostRecentCaremap();
                let redirectTo: string;
                if (lastTab?.dataId === 'caremap-tab') {
                    redirectTo = `/caremaps/${careMap?.careMapId}`;
                } else if (lastTab?.dataId === 'notes-tab') {
                    redirectTo = `/notes/${careMap?.careMapId}`;
                } else {
                    redirectTo = `/care/${careMap?.careMapId}`;
                }
                return (
                    <Redirect to={redirectTo} />
                );
            }} />

            <Route path="/care/:caremapId" exact render={routeParams => (
                <CarePage caremapId={routeParams.match.params.caremapId} />
            )} />
        </>
    );
};
